module.exports = __webpack_public_path__ + "img/tuceng17.2fc9e35b.png";